import React, { Component } from 'react'
import { connect } from 'react-redux'

import SceneData from '../../data/scene.json'

import Pipette from '../pipette/Pipette'
import TipBox from '../tipBox/TipBox'
import Solution from '../solution/Solution'
import BlottingPaper from '../blottingPaper/BlottingPaper'
import Trash from '../trash/Trash'
import Table from '../table/Table'
import Shelf from '../shelf/Shelf'
import PipetteRack from '../pipetteRack/PipetteRack'
import TubeStand from '../tubeStand/TubeStand'

import Group from '../group/Group'
import {
    createPipette,
    createSolution,
    createBlotPaper,
    createTipBox,
} from '../../actions';

class SceneBuilder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            components: []
        }

        this.doReduxPart(SceneData)
    }

    componentDidMount(){
        this.doCompPart(SceneData)
    }

    doReduxPart = (data) => {
        Object.keys(data).forEach((key) => {
            data[key].components.forEach(comp => {
                this.setupComponentRedux(comp)
            })
        })
    }

    doCompPart = (data) => {
        const groupArr = []
        let compArr = []

        Object.keys(data).forEach((key, index) => {
            compArr = []
            data[key].components.forEach((comp, index) => {
                compArr.push(this.buildComponent(comp, index));
            })
            groupArr.push(<Group key={index} components={compArr} position={data[key].position}/>)
        })

        this.setState({
            components: groupArr
        })
    }

    setupComponentRedux = (data) => {
        switch (data.component) {
            case "Pipette":
                this.props.createPipette({
                    props: data.props
                })
                break;

            case "Tip Box":
                this.props.createTipBox({
                    props: data.props
                })
                break;

            case "Solution":
                this.props.createSolution({
                    props: data.props
                })
                break;

            case "Blotting Paper":
                this.props.createBlotPaper({
                    props: data.props
                })
                break;

            case "Tube Stand":
                //No Redux setup needed for Tube Stand
                break;


            case "Trash":
                //No Redux setup needed for Trash
                break;

            case "Table":
                //No Redux setup needed for Table
                break;

            case "Shelf":
                //No Redux setup needed for Shelf
                break;

            case "Pipette Rack":
                //No Redux setup needed for Pipette Rack
                break;

            default:
                break;
        }
    }

    buildComponent = (data, index) => {
        switch (data.component) {
            case "Pipette":
                return (<Pipette key={index} pos={data.position} type={data.props.type} id={data.props.id} />)

            case "Tip Box":
                return (<TipBox key={index} pos={data.position} type={data.props.type} id={data.props.id} />)

            case "Solution":
                return (<Solution key={index} pos={data.position} solution={data.props.solution} id={data.props.id} />)

            case "Blotting Paper":
                return (<BlottingPaper key={index} pos={data.position} id={data.props.id} />)

            case "Trash":
                return (<Trash key={index} pos={data.position} id={data.props.id} />)

            case "Table":
                return (<Table key={index} pos={data.position} id={data.props.id} />)

            case "Shelf":
                return (<Shelf key={index} pos={data.position} id={data.props.id} />)

            case "Pipette Rack":
                return (<PipetteRack key={index} pos={data.position} id={data.props.id} />)

            case "Tube Stand":
                return <TubeStand key={index} pos={data.position} id={data.props.id} />;

            default:
                break;
        }
    }

    render() {
        return (
            this.state.components
        );
    }
}

const mapStateToProps = (state) => {
    return {
        test: state.pipette.pipettes
    }
  }

  export default connect(mapStateToProps, {
    createPipette,
    createSolution,
    createBlotPaper,
    createTipBox,
  })(SceneBuilder)
